import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';

/** True lorsque l’app tourne dans le conteneur Capacitor (APK / IPA). */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

const NATIVE_BARS_ATTR = 'nativeBars';

/**
 * Style des barres système (bord à bord).
 * `dark` = icônes claires sur fond sombre ; `light` = icônes sombres sur fond clair.
 */
export function setNativeSystemBarsStyle(style: 'light' | 'dark'): void {
  if (!isNativeApp()) return;
  void SystemBars.setStyle({
    style: style === 'dark' ? SystemBarsStyle.Dark : SystemBarsStyle.Light,
  });
}

/** Verrouille le style (ex. login admin navy) pour ne pas se faire écraser au masquage du splash. */
export function lockNativeSystemBarsStyle(style: 'light' | 'dark'): () => void {
  document.documentElement.setAttribute(`data-${NATIVE_BARS_ATTR}`, style);
  setNativeSystemBarsStyle(style);
  return () => {
    document.documentElement.removeAttribute(`data-${NATIVE_BARS_ATTR}`);
    syncNativeSystemBarsStyle(window.location.pathname);
  };
}

export function syncNativeSystemBarsStyle(pathname: string): void {
  const locked = document.documentElement.getAttribute(`data-${NATIVE_BARS_ATTR}`);
  if (locked === 'dark' || locked === 'light') {
    setNativeSystemBarsStyle(locked);
    return;
  }
  const darkChrome = pathname === '/connexion' || pathname === '/inscription';
  setNativeSystemBarsStyle(darkChrome ? 'dark' : 'light');
}

/**
 * Deep link OAuth natif (Custom Tabs → app).
 * Format [scheme]://[host] exigé par Kuunda Auth.
 * Ne pas utiliser https://localhost : Chrome Custom Tabs ne le rend pas
 * à l’app de façon fiable (autoVerify impossible), et Kuunda retombe
 * alors sur le Site URL (isbd360.com) → session non hydratée hors WebView.
 */
export const NATIVE_OAUTH_SCHEME = 'com.arowtechnologie.isbd';
export const NATIVE_OAUTH_HOST = 'login-callback';

export function getNativeOAuthRedirectUrl(): string {
  return `${NATIVE_OAUTH_SCHEME}://${NATIVE_OAUTH_HOST}`;
}

/** @deprecated Prefer getNativeOAuthRedirectUrl — conservé pour compat docs/legacy. */
export function getNativeOrigin(): string {
  return 'https://localhost';
}

export function getOAuthRedirectUrl(): string {
  if (isNativeApp()) {
    return getNativeOAuthRedirectUrl();
  }
  return `${window.location.origin}/auth/callback`;
}

/** Retour après clic sur le lien « mot de passe oublié » (e-mail). */
export function getPasswordRecoveryRedirectUrl(): string {
  return getOAuthRedirectUrl();
}
